class NavbarGiftSearch {
  constructor() {
    this.inputs = document.querySelectorAll('.navbar-gift-search-input');
    this.dropdowns = document.querySelectorAll('.dropdown-gift-search-suggestions');

    if (this.inputs.length > 0 && this.dropdowns.length > 0) {
      this.init();
    }
  }

  init() {
    this.searchUrl = '/gift-packages-search-suggestions';
    this.debounceTime = 300;
    this.minQueryLength = 2;

    this.bindEvents();
  }

  bindEvents() {
    this.inputs.forEach((input, index) => {
      const dropdown = this.dropdowns[index] || this.dropdowns[0]; // fallback to first dropdown
      if (!dropdown) return;

      const resultsContainer = dropdown.querySelector('.gift-search-results');
      if (!resultsContainer) return;

      // Debounced search on input
      let searchTimeout;
      input.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const query = e.target.value.trim();

        if (query.length < this.minQueryLength) {
          this.hideDropdown(dropdown);
          return;
        }

        searchTimeout = setTimeout(() => {
          this.performSearch(query, dropdown, resultsContainer);
        }, this.debounceTime);
      });

      // Show dropdown on focus if there's content
      input.addEventListener('focus', () => {
        if (resultsContainer.innerHTML && input.value.trim().length >= this.minQueryLength) {
          this.showDropdown(dropdown);
        }
      });

      // Hide dropdown when clicking outside (only for desktop, not mobile drawer)
      document.addEventListener('click', (e) => {
        // Check if this is a mobile dropdown (inside a drawer)
        const isMobileDropdown = dropdown.closest('[data-button-tag="search-bar-mobile"]');

        // Only hide dropdown on outside click for desktop, not mobile
        if (!isMobileDropdown && !input.contains(e.target) && !dropdown.contains(e.target)) {
          this.hideDropdown(dropdown);
        }
      });

      // Handle keyboard navigation
      input.addEventListener('keydown', (e) => {
        if (!dropdown.classList.contains('hidden')) {
          this.handleKeyboardNavigation(e, resultsContainer, dropdown, input);
        }
      });

      // For mobile dropdown, hide results when drawer is closed
      const isMobileDropdown = dropdown.closest('[data-button-tag="search-bar-mobile"]');
      if (isMobileDropdown) {
        const drawer = dropdown.closest('x-drawer');
        if (drawer) {
          // Listen for drawer close events
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (drawer.classList.contains('hidden')) {
                  this.hideDropdown(dropdown);
                  input.value = ''; // Clear search input when drawer closes
                }
              }
            });
          });
          observer.observe(drawer, { attributes: true });
        }
      }
    });
  }

  async performSearch(query, dropdown, resultsContainer) {
    try {
      const url = new URL(this.searchUrl, window.location.origin);
      url.searchParams.set('q', query);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      this.updateDropdown(html, resultsContainer);
      this.showDropdown(dropdown);
    } catch (error) {
      console.error('Gift search error:', error);
      this.hideDropdown(dropdown);
    }
  }

  updateDropdown(html, resultsContainer) {
    resultsContainer.innerHTML = html;

    // Bind click events to dropdown items
    // const items = resultsContainer.querySelectorAll('.dropdown-item[data-url]');
    // items.forEach(item => {
    //   item.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     const url = item.dataset.url;
    //     if (url) {
    //       window.location.href = url;
    //     }
    //   });
    // });
  }

  showDropdown(dropdown) {
    dropdown.classList.remove('hidden');
  }

  hideDropdown(dropdown) {
    dropdown.classList.add('hidden');
  }

  handleKeyboardNavigation(e, resultsContainer, dropdown, input) {
    const items = resultsContainer.querySelectorAll('.dropdown-item');
    if (items.length === 0) return;

    const currentSelected = resultsContainer.querySelector('.dropdown-item.selected');
    let selectedIndex = currentSelected ? Array.from(items).indexOf(currentSelected) : -1;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
        this.updateSelection(items, selectedIndex);
        break;

      case 'ArrowUp':
        e.preventDefault();
        selectedIndex = Math.max(selectedIndex - 1, 0);
        this.updateSelection(items, selectedIndex);
        break;

      case 'Enter':
        e.preventDefault();
        if (currentSelected) {
          const url = currentSelected.dataset.url;
          if (url) {
            window.location.href = url;
          }
        }
        break;

      case 'Escape':
        e.preventDefault();
        this.hideDropdown(dropdown);
        input.blur();
        break;
    }
  }

  updateSelection(items, selectedIndex) {
    // Remove previous selection
    items.forEach(item => item.classList.remove('selected', 'bg-gray-100'));

    // Add selection to current item
    if (selectedIndex >= 0 && selectedIndex < items.length) {
      const selectedItem = items[selectedIndex];
      selectedItem.classList.add('selected', 'bg-gray-100');

      // Scroll into view if needed
      selectedItem.scrollIntoView({ block: 'nearest' });
    }
  }
}

export default NavbarGiftSearch;
